export default __webpack_public_path__ + "static/media/KapraySunLogo.dfe0a75e.png";